import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=55359eb4&"
import script from "./avatar.vue?vue&type=script&lang=js&"
export * from "./avatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55359eb4')) {
      api.createRecord('55359eb4', component.options)
    } else {
      api.reload('55359eb4', component.options)
    }
    module.hot.accept("./avatar.vue?vue&type=template&id=55359eb4&", function () {
      api.rerender('55359eb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/tax-payer/avatar.vue"
export default component.exports